// Suivi des mangas (localStorage) : lecture, ecriture et detection des nouveautes.
const KEY = 'mc_follows';
// Meme fenetre que le carrousel des dernieres sorties : un chapitre est "nouveau" 4 jours.
export const NEW_DAYS = 4;

export function getFollows() {
    try {
        const list = JSON.parse(localStorage.getItem(KEY));
        return Array.isArray(list) ? list : [];
    } catch (e) {
        return [];
    }
}

export function setFollows(list) {
    try {
        localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
        // stockage indisponible : le suivi reste en memoire pour la session
    }
}

export function toggleFollowSlug(slug) {
    const list = getFollows();
    const index = list.indexOf(slug);
    if (index === -1) list.push(slug); else list.splice(index, 1);
    setFollows(list);
    return index === -1;
}

// Un manga a une nouveaute quand son dernier chapitre est sorti recemment (meme regle que le carrousel).
export function hasNewChapter(comic) {
    const last = comic && comic.last_chapter;
    if (!last || !last.published_on) return false;
    const age = Date.now() - Date.parse(last.published_on);
    return age >= 0 && age < NEW_DAYS * 86400000;
}

// Temps relatif en francais ("il y a 5 min", "il y a 3 j"...).
export function frenchTime(dateString) {
    const diff = Date.now() - Date.parse(dateString);
    if (!isFinite(diff)) return '';
    if (diff < 60000) return "à l'instant";
    const minutes = Math.floor(diff / 60000);
    if (minutes < 60) return `il y a ${minutes} min`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `il y a ${hours} h`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `il y a ${days} j`;
    return new Date(dateString).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' });
}

// --- Synchronisation avec le compte lecteur (connecte) ---

function apiBase() {
    return typeof API_BASE_URL !== 'undefined' ? API_BASE_URL : '/api';
}

function loggedIn() {
    return typeof LOGGED_IN !== 'undefined' && LOGGED_IN;
}

// Recupere les suivis du compte et fusionne avec la liste locale.
export function syncFollows() {
    if (!loggedIn()) return Promise.resolve(null);
    const local = getFollows();
    return axios.get(apiBase() + '/reader/follows', { params: { _fresh: Date.now() } })
        .then(res => {
            const server = Array.isArray(res.data.follows) ? res.data.follows : [];
            if (!local.length) {
                setFollows(server);
                return server;
            }
            return axios.post(apiBase() + '/reader/follows/merge', { slugs: local })
                .then(() => {
                    const union = server.slice();
                    local.forEach(slug => { if (union.indexOf(slug) === -1) union.push(slug); });
                    setFollows(union);
                    return union;
                });
        })
        .catch(() => null);
}

// Informe le compte d'un changement de suivi (silencieux en cas d'echec).
export function pushFollow(slug, follow) {
    if (!loggedIn() || !slug) return Promise.resolve();
    return axios.post(apiBase() + '/reader/follows', { slug: slug, follow: follow ? 1 : 0 }).catch(() => {});
}
